import type { ReactNode } from 'react';
import type { NavItem } from './MobileShell';
import { SidebarContent } from './SidebarContent';

export type { NavItem } from './MobileShell';

interface DesktopShellProps {
  navItems: NavItem[];
  children: ReactNode;
  title?: string;
  actions?: ReactNode;
  breadcrumb?: ReactNode;
  banner?: ReactNode;
  churchName?: string;
  user?: { name: string; role: string };
  onNavigate?: (href: string) => void;
}

export const DesktopShell = ({
  navItems,
  children,
  title,
  actions,
  breadcrumb,
  banner,
  churchName,
  user,
  onNavigate,
}: DesktopShellProps) => {
  return (
    <div className="flex h-dvh bg-page">
      {/* Sidebar */}
      <aside className="flex w-60 shrink-0 flex-col border-r border-line bg-surface">
        <SidebarContent navItems={navItems} churchName={churchName} user={user} onNavigate={onNavigate} />
      </aside>

      {/* Main Content */}
      <div className="flex min-w-0 flex-1 flex-col overflow-hidden">
        <header className="no-print border-b border-line bg-surface">
          <div className="flex items-center justify-between gap-4 px-8 py-4">
            <div className="min-w-0">
              {breadcrumb}
              {title && <h1 className="truncate text-title font-semibold text-ink">{title}</h1>}
            </div>
            {actions && <div className="shrink-0">{actions}</div>}
          </div>
        </header>

        {banner && <div className="border-b border-line bg-page">{banner}</div>}

        <main data-page-scroller className="flex-1 overflow-y-auto px-8 py-6">
          <div className="mx-auto max-w-[1200px]">{children}</div>
        </main>
      </div>
    </div>
  );
};
